import React from 'react'
import { cn } from '@/lib/utils'

/**
 * A sleek, modern pin icon that replaces the standard Lucide pin.
 * It features a more geometric design with a sharp needle and a refined head.
 */
export const PinIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('lucide-pin-custom', className)}
      {...props}
    >
      {/* Sharp needle */}
      <line x1="12" y1="17" x2="12" y2="22" fill="none" />

      {/* Minimalist head */}
      <path d="M7 11h10" />
      <path d="M9 11V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6" />
      <path d="M6 14v-1a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1" />
      <path d="M6 14h12v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1z" />
    </svg>
  )
}

export default PinIcon
